import React, { useState } from 'react';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { HiOutlineMenuAlt1, IoMdNotificationsOutline } from "react-icons/all";
import { WiCloudRefresh } from "react-icons/wi";
import { Colors } from "../../../helpers/Color";
import { Avatar, Badge } from "antd";
import {
    Switch,
    Route,
} from "react-router-dom";
import DashBoard from "../../../app/dashBoard";
import Products from "../../../app/products";
import Orders from "../../../app/orders";
import Sales from "../../../app/sales";
import AddedProducts from "../../../app/addedProducts";
import AddProducts from "../../../app/addProducts";
import EditProduct from "../../../app/editProduct";
import Users from "../../../app/users";
import OrderView from "../../../app/orderView";
import Categories from "../../../app/categories";
import SubCategories from "../../../app/subCategories";
import AddCategory from "../../../app/categories/section/addCategory";
import AddSubCategory from "../../../app/subCategories/section/addSubCategory";
import EditCategory from "../../../app/categories/section/editCategory";
import EditSubCategory from "../../../app/subCategories/section/editSubCategory";
import SpecialityCategory from "../../../app/specialityCategory";
import SpecialitySubCategory from "../../../app/specialitySubCategory";
import AddSpecialityCategory from "../../../app/specialityCategory/section/addSpecialityCategory";
import EditSpecialityCategory from "../../../app/specialityCategory/section/editSpecialityCategory";
import AddSpecialitySubCategory from "../../../app/specialitySubCategory/section/addSpecialitySubCategory";
import EditSpecialitySubCategory from "../../../app/specialitySubCategory/section/editSpecialitySubCategory";
import Pincode from "../../../app/pincode";
import Banners from "../../../app/banners";
import AddCarouselBanner from "../../../app/banners/sections/addCarouselBanner";
import AddAdsBanner from "../../../app/banners/sections/addAdsBanner";
import EditAdsBanner from "../../../app/banners/sections/editAdsBanner";
import EditCarouselBanner from "../../../app/banners/sections/editCarouselBanner";
import MainBarCategories from "../../../app/mainBarCategories";
import NotificationPage from "../../../app/notification";
import AddNewNotification from "../../../app/notification/section/addNewNotification";
import ProductRequestPage from "../../../app/productRequests";
import DynamicCategories from "../../../app/dynamicCategories";
import PromoCodePage from "../../../app/promocode";
import NewProductRequestsPage from "../../../app/newProductRequests";
import BlogsPage from "../../../app/blogs";
import AddBlogPage from "../../../app/addBlog";
import EditBlogPage from "../../../app/editBlog";
import UserViewPage from "../../../app/userView";
import StatePage from "../../../app/state";
import { useDispatch } from 'react-redux';
import { etabxServerUrl, backendUrl } from 'index';
import { setProduct } from 'components/redux/slice/ProductSlice';
import axios from "axios";
import EditPageBanner from 'components/app/banners/sections/pageBanner/section/EditPageBanner';
import AddMedia from 'components/app/addMedia/AddMedia';
import connection from 'components/app/auth/api';
import Groups from 'components/app/Groups';
import AddGroup from 'components/app/Groups/section/addGroup';
import EditGroup from 'components/app/Groups/section/editGroup';
import Brands from 'components/app/Brands';
import AddBrand from 'components/app/Brands/addBrand';
import EditBrand from 'components/app/Brands/editBrand';

const avatarUrl = "data:image/jpeg;base64,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"

const AppBar = ({ setDrawerOpen }) => {

    const is430pxBelow = useMediaQuery('(max-width:430px)')
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const fetchProduct = async () => {
        setLoading(true)
        try {
            await connection.post(backendUrl + '/post/getProducts').then(res => {
                console.log(res.data.data)
                dispatch(setProduct(res.data.data.Response.Data.ProductDetails.Products))
                setLoading(false)
            })
        } catch (e) {
            setLoading(false)
            console.log(e.message)
        }

    }
    return (
        <div className={'app-bar'}>
            <div className={'left-icons'}>
                <HiOutlineMenuAlt1 onClick={() => setDrawerOpen(prev => !prev)} className={'open-icon'} />
                {
                    !is430pxBelow ?
                        <>
                            <h6>Dashboard</h6>
                            <h6>Users</h6>
                            <h6>Settings</h6>
                        </> : <></>
                }
            </div>
            <div className={'right-icons'}>
                <WiCloudRefresh className={'profile'} onClick={async () => await fetchProduct()} />
                <Badge count={5} size={'small'}>
                    <IoMdNotificationsOutline className={'notify'} />
                </Badge>
                <Avatar className={'profile'} src={avatarUrl} />
            </div>
        </div>
    )
}

const AppContainer = ({ setDrawerOpen, drawerOpen }) => {

    const useStyles = makeStyles(() => ({
        container: {
            '& .app-bar': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 15px',
                '& .left-icons': {
                    display: 'flex',
                    alignItems: 'center',
                    '& .open-icon': {
                        fontSize: '26px',
                        color: Colors.darkText,
                        margin: '0 10px 0 0'
                    },
                    '& h6': {
                        margin: '0 15px',
                        color: Colors.darkText,
                        fontSize: '13px'
                    }
                },
                '& .right-icons': {
                    display: 'flex',
                    alignItems: 'center',
                    '& .notify': {
                        fontSize: '22px',
                        color: Colors.darkText,
                    },
                    '& .ant-scroll-number': {
                        fontSize: '9px',
                    },
                    '& .profile': {
                        fontSize: '22px',
                        color: Colors.darkText,
                        margin: '0 15px 0 25px'
                    },
                },
                borderBottom: `1px solid ${Colors.lightBorder}`
            }
        },
        main: {
            padding: '20px',
        }
    }))

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <AppBar setDrawerOpen={setDrawerOpen} />
            <main className={classes.main}>
                <Switch>
                    <Route path="/promo-code">
                        <PromoCodePage />
                    </Route>
                    <Route path="/dynamic-categories">
                        <DynamicCategories />
                    </Route>
                    <Route path="/push-notification">
                        <NotificationPage />
                    </Route>
                    <Route path="/blog/edit-blog/:id">
                        <EditBlogPage />
                    </Route>
                    <Route path="/blog/add-blog">
                        <AddBlogPage />
                    </Route>
                    <Route path="/blog">
                        <BlogsPage />
                    </Route>
                    <Route path="/sales">
                        <Sales />
                    </Route>
                    <Route path="/state">
                        <StatePage />
                    </Route>
                    <Route path="/pincode">
                        <Pincode />
                    </Route>
                    <Route path="/users/:id">
                        <UserViewPage />
                    </Route>
                    <Route path="/users">
                        <Users />
                    </Route>
                    <Route path="/new-product-requests">
                        <NewProductRequestsPage />
                    </Route>
                    <Route path="/product-requests">
                        <ProductRequestPage />
                    </Route>
                    <Route path="/main-bar-category">
                        <MainBarCategories />
                    </Route>
                    <Route path="/order/:id">
                        <OrderView />
                    </Route>
                    <Route path="/banners/ads-banner/edit/:id">
                        <EditAdsBanner />
                    </Route>
                    <Route path="/banners/carousel-banner/edit/:id">
                        <EditCarouselBanner />
                    </Route>
                    <Route path="/banners/add-ads-banner">
                        <AddAdsBanner />
                    </Route>
                    <Route path="/banners/add-carousel-banner">
                        <AddCarouselBanner />
                    </Route>
                    <Route path="/banners">
                        <Banners />
                    </Route>
                    <Route path="/speciality-sub-categories/edit/:id">
                        <EditSpecialitySubCategory />
                    </Route>
                    <Route path="/speciality-sub-categories/add-sub-category">
                        <AddSpecialitySubCategory />
                    </Route>
                    <Route path="/speciality-sub-categories">
                        <SpecialitySubCategory />
                    </Route>
                    <Route path="/speciality-categories/edit/:id">
                        <EditSpecialityCategory />
                    </Route>
                    <Route path="/speciality-categories/add-category">
                        <AddSpecialityCategory />
                    </Route>
                    <Route path="/speciality-categories">
                        <SpecialityCategory />
                    </Route>

                    <Route path="/general-sub-categories/edit/:id">
                        <EditSubCategory />
                    </Route>
                    <Route path="/general-sub-categories/add-sub-category">
                        <AddSubCategory />
                    </Route>
                    <Route path="/general-sub-categories">
                        <SubCategories />
                    </Route>
                    <Route path="/general-categories/edit/:id">
                        <EditCategory />
                    </Route>
                    <Route path="/general-categories/add-category">
                        <AddCategory />
                    </Route>
                    <Route path="/groups/add-group">
                        <AddGroup />
                    </Route>
                    <Route path="/group/edit/:id">
                        <EditGroup />
                    </Route>
                    <Route path="/groups">
                        <Groups />
                    </Route>
                    <Route path="/brands">
                        <Brands />
                    </Route>
                    <Route path="/brand/add-brand">
                        <AddBrand />
                    </Route>
                    <Route path="/brand/edit/:id">
                        <EditBrand />
                    </Route>

                    <Route path="/general-categories">
                        <Categories />
                    </Route>
                    <Route path="/orders">
                        <Orders />
                    </Route>
                    <Route path="/edit-product/:id">
                        <EditProduct />
                    </Route>
                    <Route path="/add-product/:name">
                        <AddProducts />
                    </Route>
                    <Route path="/added-products">
                        <AddedProducts />
                    </Route>
                    <Route path="/media">
                        <AddMedia />
                    </Route>
                    <Route path="/page-banner/edit/:id">
                        <EditPageBanner />
                    </Route>
                    <Route path="/all-products">
                        <Products />
                    </Route>
                    <Route path="/">
                        <DashBoard />
                    </Route>

                </Switch>
            </main>
        </div>
    );
};

export default AppContainer;
